import "./App.css";
import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { TbBuildingSkyscraper } from "react-icons/tb";

const communities = [
  {
    title: "Chitravilasa Garden City",
    image: "/communities/image1.jpg",
  },
  {
    title: "Premium Residences",
    image: "/communities/image2.jpg",
  },
  {
    title: "Luxury Apartments",
    image: "/communities/image3.jpg",
  },
];

export default function App() {
  const [activeTab, setActiveTab] = useState("photos");
  const [currentSlide, setCurrentSlide] = useState(0);
  const [showMore, setShowMore] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const heroSlides = [
    {
      type: "video",
      src: "https://cdn.coverr.co/videos/coverr-modern-luxury-house-1560088198054?download=1080p",
    },
    {
      type: "image",
      src: "https://images.unsplash.com/photo-1600585154526-990dced4db0d?q=80&w=1400&auto=format&fit=crop",
    },
    {
      type: "image",
      src: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=1400&auto=format&fit=crop",
    },
    {
      type: "image",
      src: "https://images.unsplash.com/photo-1494526585095-c41746248156?q=80&w=1400&auto=format&fit=crop",
    },
  ];

  useEffect(() => {
    const currentItem = heroSlides[currentSlide];
    const duration = currentItem.type === "video" ? 7000 : 5000;

    const slider = setTimeout(() => {
      setCurrentSlide((prev) =>
        prev === heroSlides.length - 1 ? 0 : prev + 1
      );
    }, duration);

    return () => clearTimeout(slider);
  }, [currentSlide]);

  // Close menu when clicking on a link
  const handleMenuClick = () => {
    setMenuOpen(false);
  };

  return (
    <div className="app">
      {/* HERO SECTION */}
      <section className="hero" id="home">
        <div className="hero-slider">
          <video
            className="hero-video"
            autoPlay
            muted
            loop
            playsInline
          >
            <source src="/videos/video1.mp4" type="video/mp4" />
          </video>
        </div>

        <motion.div>
        </motion.div>
      </section>

      {/* NAVBAR */}
      <motion.nav
        className="navbar"
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 1 }}
      >
        <div className="logo">
          <img
            src="/logo.png"
            alt="AK Infra Holdings"
            className="navbar-logo"
          />
          <div className="logo-text">
            <h1>AK INFRA HOLDINGS</h1>
          </div>
        </div>

        {/* HAMBURGER ICON */}
        <div
          className="hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? (
            <FaTimes size={30} />
          ) : (
            <TbBuildingSkyscraper size={30} />
          )}
        </div>

        {/* MENU */}
        <div className={menuOpen ? "menu active" : "menu"}>
          <a href="#home" onClick={handleMenuClick}>HOME</a>
          <a href="#about" onClick={handleMenuClick}>ABOUT</a>
          <a href="#agents" onClick={handleMenuClick}>AGENTS</a>
          <a href="#gallery" onClick={handleMenuClick}>GALLERY</a>
          <a href="#communities" onClick={handleMenuClick}>COMMUNITIES</a>
          <a href="#buyers" onClick={handleMenuClick}>BUYERS</a>
          <a href="#sellers" onClick={handleMenuClick}>SELLERS</a>
          <a href="#leadership" onClick={handleMenuClick}>LEADERSHIP</a>
          <a href="#contact" onClick={handleMenuClick}>CONTACT</a>
          <a href="#maps" onClick={handleMenuClick}>MAPS</a>
        </div>
      </motion.nav>

      {/* HERO CONTENT */}
      <motion.div
        className="hero-content"
        initial={{ opacity: 0, y: 80 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2 }}
      >
      </motion.div>

      {/* BUSINESS ACTIVITY / ABOUT SECTION */}
      <motion.section
        className="business-activity"
        id="about"
        initial={{ opacity: 0, y: 100 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      >
        <p className="about-small">ABOUT AK INFRA HOLDINGS</p>

        <h1>Business Activity</h1>

        <div className="business-text">
          <motion.img
            src="/about/image1.1.jpg"
            alt="AK Infra Holdings"
            className="business-image"
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
          />

          <motion.p
            initial={{ opacity: 0, x: 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
          >
            <strong>M/S AK INFRA HOLDINGS</strong> is a registered real estate
            development firm engaged in the conceptualization, planning,
            construction, and sale of residential and commercial properties,
            in compliance with the provisions of the Real Estate
            (Regulation and Development) Act, 2016 (RERA).

            <br /><br />

            The company's core operations include acquisition and development
            of land, obtaining statutory approvals, preparing architectural
            and structural designs, and executing complete construction works
            through quality-driven processes.

            <br /><br />

            The firm specializes in delivering apartment complexes, gated
            communities, and commercial spaces that meet high standards of
            design, durability, and functionality.

            <br /><br />

            M/S AK INFRA HOLDINGS is committed to maintaining ethical business
            practices, financial integrity, and customer satisfaction.
          </motion.p>
        </div>
      </motion.section>

      {/* MEET AGENTS SECTION */}
      <section className="agents" id="agents">
        <motion.div
          className="agents-top"
          initial={{
            opacity: 0,
            y: 100,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          viewport={{ once: true }}
          transition={{
            duration: 1,
          }}
        >
          <p className="agent-small">OUR PROFESSIONAL TEAM</p>
          <h1>Meet Our AK Infra Holdings Team</h1>

          <p className="agent-desc">
            AK Infra Holdings is a trusted real estate
            development company dedicated to building
            sustainable communities, modern residential
            projects, and value-driven investment
            opportunities. Our commitment to quality,
            integrity, and excellence drives every project
            we undertake.
          </p>
        </motion.div>

        {/* AGENTS CARDS */}
        <div className="agent-grid">
          {[1, 2, 3].map((item, index) => (
            <motion.div
              className="agent-card"
              key={index}
              initial={{
                opacity: 0,
                y: 100,
              }}
              whileInView={{
                opacity: 1,
                y: 0,
              }}
              viewport={{ once: true }}
              transition={{
                duration: 1,
                delay: index * 0.3,
              }}
              whileHover={{
                y: -10,
                scale: 1.03,
              }}
            >
              <h2>
                {index === 0
                  ? "James Walker"
                  : index === 1
                    ? "Sophia Miller"
                    : "Daniel Brooks"}
              </h2>

              <span>Luxury Property Expert</span>

              <p>
                Helping clients find premium homes
                with modern architecture and
                exceptional comfort.
              </p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* GALLERY SECTION */}
      <section className="gallery" id="gallery">
        <motion.div
          className="gallery-top"
          initial={{
            opacity: 0,
            y: 80,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          viewport={{ once: true }}
          transition={{
            duration: 1,
          }}
        >
          <p className="gallery-small">GALLERY</p>
          <h1>Photos & Videos</h1>
        </motion.div>

        {/* BUTTONS */}
        <div className="gallery-buttons">
          <button
            className={
              activeTab === "photos"
                ? "active-gallery"
                : ""
            }
            onClick={() => setActiveTab("photos")}
          >
            Photos
          </button>

          <button
            className={
              activeTab === "videos"
                ? "active-gallery"
                : ""
            }
            onClick={() => setActiveTab("videos")}
          >
            Videos
          </button>
        </div>

        {/* PHOTOS */}
        {activeTab === "photos" && (
          <>
            <div className="gallery-grid">
              {[
                "/gallery/image1.jpg",
                "/gallery/image2.jpg",
                "/gallery/image3.jpg",
                "/gallery/image4.jpg",
                "/gallery/image5.jpg",
                "/gallery/image6.jpg",
                "/gallery/image7.jpg",
                "/gallery/image8.jpg",
                "/gallery/image9.jpg",
                "/gallery/image10.jpg",
                "/gallery/image11.jpg",
                "/gallery/image12.jpg",
                "/gallery/image13.jpg",
              ]
                .slice(0, showMore ? 13 : 6)
                .map((img, index) => (
                  <motion.div
                    className="gallery-card"
                    key={index}
                    initial={{ opacity: 0, y: 100 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{
                      duration: 0.8,
                      delay: index * 0.1,
                    }}
                  >
                    <img src={img} alt={`Property ${index + 1}`} />
                  </motion.div>
                ))}
            </div>

            {/* READ MORE BUTTON */}
            <div className="read-more-box">
              <button onClick={() => setShowMore(!showMore)}>
                {showMore ? "Show Less" : "Read More"}
              </button>
            </div>
          </>
        )}

        {/* VIDEOS */}
        {activeTab === "videos" && (
          <div className="video-grid">
            {[
              "/videos/video2.mp4",
              "/videos/video3.mp4",
            ].map((video, index) => (
              <motion.div
                className="video-card"
                key={index}
                initial={{ opacity: 0, scale: 0.7 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{
                  duration: 0.8,
                  delay: index * 0.3,
                }}
              >
                <video controls width="100%">
                  <source src={video} type="video/mp4" />
                </video>
              </motion.div>
            ))}
          </div>
        )}
      </section>

      {/* COMMUNITIES SECTION */}
      <section className="communities" id="communities">
        <div className="top-text">
          <p>Communities</p>

          <motion.p
            className="community-desc"
            initial={{ opacity: 0, y: -100 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{
              duration: 1.2,
              ease: "easeOut",
            }}
          >
            AK Infra Holdings is committed to creating
            modern and sustainable communities that offer
            comfort, quality, and long-term value.
            Our flagship project, Chitravilasa Garden City,
            reflects our dedication to excellence,
            transparency, and customer satisfaction.
          </motion.p>
        </div>

        <div className="community-grid">
          {communities.map((item, index) => (
            <motion.div
              className="community-card"
              key={index}
              initial={{
                opacity: 0,
                y: 80,
                scale: 0.8,
              }}
              whileInView={{
                opacity: 1,
                y: 0,
                scale: 1,
              }}
              viewport={{ once: true }}
              transition={{
                duration: 1,
                delay: index * 0.3,
              }}
              whileHover={{
                scale: 1.05,
                y: -15,
              }}
            >
              <motion.img
                src={item.image}
                alt={item.title}
                onError={() =>
                  console.log("Image not found:", item.image)
                }
                animate={{
                  y: [0, -8, 0],
                }}
                transition={{
                  duration: 6,
                  repeat: Infinity,
                  ease: "easeInOut"
                }}
              />

              <div className="dark"></div>

              <motion.h2
                initial={{
                  opacity: 0,
                  y: 50,
                }}
                whileInView={{
                  opacity: 1,
                  y: 0,
                }}
                viewport={{ once: true }}
                transition={{
                  duration: 1,
                  delay: 1 + index * 0.4,
                }}
              >
                {item.title}
              </motion.h2>
            </motion.div>
          ))}
        </div>
      </section>

      {/* BUYERS SECTION */}
      <section className="buyers" id="buyers">
        {/* LEFT IMAGE */}
        <motion.div
          className="buyers-image"
          initial={{
            opacity: 0,
            x: -150,
          }}
          whileInView={{
            opacity: 1,
            x: 0,
          }}
          viewport={{ once: true }}
          transition={{
            duration: 1.2,
          }}
        >
          <motion.img
            src="https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?q=80&w=1200&auto=format&fit=crop"
            alt="Buyers"
            animate={{
              y: [0, -8, 0],
            }}
            transition={{
              duration: 6,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          />
        </motion.div>

        {/* RIGHT CONTENT */}
        <motion.div
          className="buyers-content"
          initial={{
            opacity: 0,
            x: 150,
          }}
          whileInView={{
            opacity: 1,
            x: 0,
          }}
          viewport={{ once: true }}
          transition={{
            duration: 1.2,
          }}
        >
          <p className="buyers-small">FOR BUYERS</p>

          <h1>
            Trusted By
            Thousands Of Buyers
          </h1>

          <p className="buyers-desc">
            AK Infra Holdings helps customers discover
            premium residential plots, gated communities,
            and thoughtfully planned real estate projects.
            With a commitment to transparency, quality,
            and customer satisfaction, we provide trusted
            guidance to help you make confident property
            investment decisions.
          </p>

          {/* COUNTS */}
          <div className="buyers-counts">
            <motion.div
              className="count-box"
              whileHover={{
                scale: 1.05,
              }}
            >
              <h2>10K+</h2>
              <span>Happy Buyers</span>
            </motion.div>

            <motion.div
              className="count-box"
              whileHover={{
                scale: 1.05,
              }}
            >
              <h2>500+</h2>
              <span>Luxury Homes</span>
            </motion.div>

            <motion.div
              className="count-box"
              whileHover={{
                scale: 1.05,
              }}
            >
              <h2>24/7</h2>
              <span>Support</span>
            </motion.div>
          </div>

          <button>
            Start Buying
          </button>
        </motion.div>
      </section>

      {/* SELLERS SECTION */}
      <section className="sellers" id="sellers">
        {/* LEFT IMAGE */}
        <motion.div
          className="sellers-left"
          initial={{
            opacity: 0,
            x: -120,
          }}
          whileInView={{
            opacity: 1,
            x: 0,
          }}
          viewport={{ once: true }}
          transition={{
            duration: 1.2,
          }}
        >
          <motion.img
            src="/sellers/image1.jpg"
            alt="Sellers"
            animate={{
              y: [0, -8, 0],
            }}
            transition={{
              duration: 6,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          />
        </motion.div>

        {/* RIGHT CONTENT */}
        <motion.div
          className="sellers-right"
          initial={{
            opacity: 0,
            x: 120,
          }}
          whileInView={{
            opacity: 1,
            x: 0,
          }}
          viewport={{ once: true }}
          transition={{
            duration: 1.2,
          }}
        >
          <p className="sellers-small">FOR SELLERS</p>

          <h1>
            Sell Your Property With Confidence
          </h1>

          <p className="sellers-desc">
            AK Infra Holdings is committed to delivering
            high-quality real estate developments with
            transparency, trust, and customer satisfaction.
            From premium residential layouts and gated
            communities to valuable investment opportunities,
            we focus on creating sustainable projects that
            offer long-term growth and value for our clients.
          </p>

          {/* COUNTS */}
          <div className="sellers-counts">
            <div className="seller-box">
              <h2>8K+</h2>
              <span>Trusted Sellers</span>
            </div>

            <div className="seller-box">
              <h2>350+</h2>
              <span>Properties Sold</span>
            </div>

            <div className="seller-box">
              <h2>98%</h2>
              <span>Client Satisfaction</span>
            </div>
          </div>

          <button>
            Start Selling
          </button>
        </motion.div>
      </section>

      {/* LEADERSHIP SECTION */}
      <section className="leadership" id="leadership">
        <motion.div
          className="leadership-top"
          initial={{ opacity: 0, y: 80 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <p className="leader-small">OUR LEADERSHIP</p>
          <h1>Meet Our Managing Partners</h1>
        </motion.div>

        <div className="leader-grid">
          <div className="leader-card">
            <h2>Mr. Sornapudi Venkata Sushil Prabhakar</h2>
            <h4>Managing Partner</h4>

            <p>
              Holds a Bachelor's degree in Electrical and Electronics Engineering
              and an MBA. He gained valuable experience in Dubai's construction
              sector and later executed industrial construction works, including
              piling and civil contracts for the RMHS Department at Jindal Steel
              Plant, Dolvi. He has successfully delivered multiple residential
              developments with a strong focus on quality, precision, and timely
              execution.
            </p>
          </div>

          <motion.div
            className="leader-card"
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2>Mr. Sornapudi Venkata Sushil Prabhakar</h2>
            <h4>Managing Partner</h4>

            <p>
              MBA graduate from GITAM University who joined the business in 2018,
              carrying forward his family's legacy in construction. His strategic
              vision, leadership, and professional expertise have played a key role
              in the growth and successful execution of AK Infra Holdings projects
              over the past seven years.
            </p>
          </motion.div>
        </div>

        <motion.div
          className="vision-box"
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2>AK Infra Holdings Vision</h2>

          <p>
            Both partners came together under AK Infra Holdings with a shared vision
            of delivering high-quality, value-driven developments. Their first joint
            venture project, Chitravilasa Garden City, reflects their commitment to
            quality, innovation, transparency, and customer satisfaction.
          </p>
        </motion.div>
      </section>

      {/* CONTACT SECTION */}
      <section className="contact" id="contact">
        {/* LEFT CONTENT */}
        <motion.div
          className="contact-left"
          initial={{
            opacity: 0,
            x: -120,
          }}
          whileInView={{
            opacity: 1,
            x: 0,
          }}
          viewport={{ once: true }}
          transition={{
            duration: 1.2,
          }}
        >
          <div className="contact-heading">
            <p className="contact-small">CONTACT US</p>
            <h1>Get In Touch With Our Team</h1>
          </div>

          {/* TOP ADDRESSES */}
          <div className="address-row">
            <div className="address-card">
              <h3>🏢 Corporate Office</h3>
              <p>
                AK INFRA HOLDINGS <br />
                3rd Floor, 11-4-3/13, TF-2,<br />
                Vridhi Chambers, Rockdale Layout,<br />
                Visakhapatnam, Andhra Pradesh - 530002
              </p>
            </div>

            <div className="address-card">
              <h3>🏗️ Project Site</h3>
              <p>
                Chitravilasa Garden City,<br />
                Opp. Narayana Residential College,<br />
                Boyapalem, Visakhapatnam,<br />
                Andhra Pradesh - 531163
              </p>
            </div>
          </div>

          {/* BUTTONS */}
          <div className="contact-buttons">
            <a href="tel:+919059583333" className="call-btn">
              Call Now
            </a>

            <a href="mailto:akinfraholdings@gmail.com" className="mail-btn">
              Send Mail
            </a>
          </div>
        </motion.div>

        {/* RIGHT IMAGE */}
        <motion.div
          className="contact-right"
          initial={{
            opacity: 0,
            x: 120,
          }}
          whileInView={{
            opacity: 1,
            x: 0,
          }}
          viewport={{ once: true }}
          transition={{
            duration: 1.2,
          }}
        >
        </motion.div>
      </section>

      {/* FOOTER SECTION */}
      <section className="footer-section">
        {/* GOOGLE MAPS SECTION */}
        <div className="maps-wrapper" id="maps">
          <div className="map-box">
            <h2>🏢 Corporate Office Location</h2>

            <div className="map-container">
              <iframe
                title="Office Location"
                src="https://maps.google.com/maps?q=Vridhi%20Chambers%20Rockdale%20Layout%20Visakhapatnam&t=&z=15&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              />
            </div>
          </div>

          <div className="map-box">
            <h2>🏗️ Project Site Location</h2>

            <div className="map-container">
              <iframe
                title="Site Location"
                src="https://maps.google.com/maps?q=Chitravilasa%20Garden%20City%20Boyapalem%20Visakhapatnam&t=&z=15&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              />
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <footer className="footer">
          <div className="footer-top">
            {/* LOGO */}
            <div className="footer-box">
              <h2>AK INFRA HOLDINGS</h2>

              <p>
                AK Infra Holdings delivers premium villas, luxury homes, and modern real estate solutions with a commitment to quality, trust, and excellence.
              </p>
            </div>

            {/* LINKS */}
            <div className="footer-box">
              <h2>Quick Links</h2>

              <a href="#home">Home</a>
              <a href="#about">About</a>
              <a href="#gallery">Gallery</a>
              <a href="#buyers">Buyers</a>
              <a href="#sellers">Sellers</a>
            </div>

            {/* CONTACT */}
            <div className="footer-box">
              <h2>Contact</h2>

              <p>📞 +91 90595 83333</p>
              <p>📧 akinfraholdings@gmail.com</p>
              <p>📍 Site Address: Chitravilasa Garden City, Opp. Narayana Residential College, Boyapalem, Visakhapatnam, Andhra Pradesh 531163</p>
            </div>
          </div>

          {/* BOTTOM */}
          <div className="footer-bottom">
            <p>
              © 2026 AK INFRA HOLDINGS Real Estate.
              All Rights Reserved.
            </p>
          </div>
        </footer>
      </section>
    </div>
  );
}